import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { ProposalSummariesState } from "../../models/mp-admin/proposal-summaries-state";

const initialState: ProposalSummariesState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.proposalSummaries.get, (state, action) =>
		_.set(_.cloneDeep(state), "loading", true)
	),
	on(MpAdminActions.proposalSummaries.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.proposalSummaries.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function proposalSummariesReducer(
	state: ProposalSummariesState,
	action: Action
): ProposalSummariesState {
	return reducer(state, action);
}
